<template>
  <main-component />
</template>

<script>
import MainComponent from '@/components/Settings/SiteConfig/index'

export default {
  components: {
    MainComponent
  },

  data () {
    return {
      modelName: 'settings/siteConfig'
    }
  },

  async created () {
    this.$store.commit(`settings/setAttr`, {
      name: 'menuSelected',
      value: 'site-config'
    })

    await this.$store.dispatch(`${this.modelName}/get`)
    this.$store.dispatch(`${this.modelName}/set`)
  }
}
</script>
